import type { FC, SVGProps } from "react";
import React from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const AiIcon: FC<Props> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
      aria-label="Ai icon"
    >
      {/* <title>Ai icon</title> */}
      <path
        d="M6.58306 12.8504L6.41624 12.399C5.78729 10.6967 4.44717 9.35457 2.74734 8.72474L2.29663 8.55762L2.74734 8.39068C4.44717 7.76068 5.78729 6.41859 6.41624 4.7164L6.58306 4.26489L6.74989 4.7164C7.37883 6.41859 8.71896 7.76068 10.4188 8.39068L10.8696 8.55762L10.4188 8.72474C8.71896 9.35457 7.37883 10.6967 6.74989 12.399L6.58306 12.8504Z"
        stroke={props.fill || "currentColor" || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3538 14.9018C15.0703 13.9693 14.3417 13.2394 13.4106 12.9556C14.3417 12.6719 15.0703 11.942 15.3538 11.0095C15.6372 11.942 16.3658 12.6719 17.2969 12.9556C16.3658 13.2394 15.6372 13.9693 15.3538 14.9018Z"
        fill={props.fill || "currentColor" || "white"}
        stroke={props.fill || "currentColor" || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AiIcon;
